import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { userloginDetails } from "../Utils/AdminAuth";
import { server } from "../../server";
import Select from "react-select";
class UserDetails extends Component {
  constructor() {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const isAdmin = lStorage?.user?.isAdmin;
    const subAdminPermission = lStorage?.permission?.per_value?.usermanagement?.children
    super();
    const savedEmbededSignup = localStorage.getItem("embededSignup") || "";

    this.state = {
      user_id: userId,
      token: userToken,
      userType: isAdmin,
      subAdminPermission: subAdminPermission,
      userDtl: lStorage,
      city: "",
      email: "",
      mobile: "",
      fullname: "",
      email_cost: "",
      country: "",
      template_editable: "",
      enable_ip_whitelist: 0,
      whiteLableIP: "",
      spam_bypass: null,
      address_line_1: "",
      selectUserDetails: "",
      seletedUserId: "",
      selectedUserType: "",
      expiryDate: "",
      employeeList: [],
      parent: "",
      awsSetting: "",
      updateExpirydate: "",
      SelecteddateFrom: "",
      successMessage: false,
      errorMessage: "",
      bgColor: "",
      specialUser: null,
      eyeIconToggle: false,
      passError: 0,
      password: "",
      cnfmPassword: "",
      embededSignup: savedEmbededSignup,
      time_zone: '',
      time_zone_value: '',
      checkBox: {
        all: null,
        sms: null,
        voice: null,
        email: null,
        whatsapp: null,
        recharge: null,
        notification: null,
        rich_media: null,
        fallback: null,
        rcs: null,
        chat: null,
        flow: null,
      },
    };
    this.eyeToggle = this.eyeToggle.bind(this);
    this.handleCnfmPass = this.handleCnfmPass.bind(this);
    this.handlePass = this.handlePass.bind(this);
    this.spamHandlar = this.spamHandlar.bind(this);
    this.handleCheckboxAll = this.handleCheckboxAll.bind(this);
  }


  componentDidMount() {
    this.getEmployee();
    this.setState({
      seletedUserId: this.props.match.params.id,
      selectedUserType: this.props.match.params.userType,
    });

    if (this.state.user_id == 4784) {
      this.setState({ specialUser: true });
    }

    fetch(`${server}/api/admin_user_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        method: "retrieve",
        type: "userdetails",
        ret_user_id: this.props.match.params.id,
        token: this.state.token,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          const parentDtl = {
            label: result.data[0].parent_name,
            value: result.data[0].parent,
          };

          this.setState({
            selectUserDetails: result.data[0],
            fullname: result.data[0].fullname,
            email: result.data[0].email,
            mobile: result.data[0].mobile,
            city: result.data[0].city,
            address_line_1: result.data[0].address_line_1,
            email_cost: result.data[0].email_cost,
            country: result.data[0].country,
            spam_bypass: result.data[0].spam_bypass,
            template_editable: result.data[0].template_editable,
            expiryDate: result.data[0].expiry,
            updateExpirydate: result.data[0].expiry,
            SelecteddateFrom: new Date(result.data[0].expiry),
            parent: parentDtl,
            whiteLableIP: result.data[0].whitelist_ip,
            enable_ip_whitelist: result.data[0].enable_ip_whitelist,
            awsSetting: result.data[0].aws_setting,
            embededSignup: result.data[0].allow_embsignup_route,
            time_zone: result.data[0].time_zone,
            time_zone_value: result.data[0].time_zone_value,
          });

          this.setState((prevState) => ({
            checkBox: {
              ...prevState.checkBox,
              ["sms"]: result.data[0].sms_menu,
              ["voice"]: result.data[0].voice_menu,
              ["email"]: result.data[0].email_menu,
              ["whatsapp"]: result.data[0].whatsapp_menu,
              ["recharge"]: result.data[0].rechrg_menu,
              ["notification"]: result.data[0].notify_menu,
              ["rich_media"]: result.data[0].rich_menu,
              ["fallback"]: result.data[0].fb_menu,
              ["rcs"]: result.data[0].rcs_menu,
              ["chat"]: result.data[0].chat_menu,
              ["flow"]: result.data[0].flow_menu,
            },
          }));

          if (
            result.data[0].sms_menu === 1 &&
            result.data[0].voice_menu === 1 &&
            result.data[0].email_menu === 1 &&
            result.data[0].whatsapp_menu === 1 &&
            result.data[0].rechrg_menu === 1 &&
            result.data[0].notify_menu === 1 &&
            result.data[0].rich_menu === 1 &&
            result.data[0].fb_menu === 1 &&
            result.data[0].rcs_menu === 1 &&
            result.data[0].chat_menu === 1 &&
            result.data[0].flow_menu === 1
          ) {
            this.setState((prevState) => ({
              checkBox: {
                ...prevState.checkBox,
                ["all"]: 1,
              },
            }));
          }
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      })
      .catch((error) => {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: "Something went wrong. Please try again later.",
        });
      });
  }




  renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {


    const years = [];
    for (let year = 1990; year <= 2050; year++) {
      years.push(year);
    }

    const months = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December",
    ];

    const handleDecreaseMonth = (event) => {
      event.preventDefault();
      decreaseMonth();
    };

    const handleIncreaseMonth = (event) => {
      event.preventDefault();
      increaseMonth();
    };

    return (
      <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
        <button
          onClick={handleDecreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{ borderStyle: "none" }}
        >
          {"<"}
        </button>

        <select
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(Number(value))}
          style={{ borderStyle: "groove", marginRight: "2px", cursor: "pointer", width: "6em" }}
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <select
          value={months[date.getMonth()]}
          onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
          style={{ borderStyle: "groove", marginRight: "2px", cursor: "pointer" }}
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <button
          onClick={handleIncreaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{ borderStyle: "none" }}
        >
          {">"}
        </button>
      </div>
    );
  };


  getEmployee() {
    fetch(
      `${server}/api/employee_user_list.php?user_id=${this.state.user_id}&method=retrieve&type=${this.state.userType}&token=${this.state.token}`
    ).then((response) => {
      response.json().then((result) => {
        //  console.log(result);
        if (result.success === true) {
          const formattedUsers = [
            { value: 1, label: "Admin (admin@datagenit.com)" },
            ...result.data.map((user) => ({
              value: user.id,
              label: `${user.fullname} (${user.email})`,
            })),
          ];
          this.setState({
            employeeList: formattedUsers,
          });
        } else {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      });
    });
  }

  UpdateUserDetails() {
    this.setState({
      successMessage: false,
      bgColor: "",
      errorMessage: "",
    });

    document.querySelector("body").scrollTo(0, 0);
    window.scrollTo(0, 0);
    this.setState({ seletedUserId: this.props.match.params.id });


    // if (!this.state.password) {
    //   this.setState({
    //     successMessage: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please enter password",
    //   });

    //   return;
    // }

    // if (!(this.state.password === this.state.cnfmPassword)) {
    //   this.setState({
    //     successMessage: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "The passwords you entered don't match",
    //   });

    //   return;
    // }

    if (this.state.time_zone === "UTC" && (this.state.time_zone_value === undefined || this.state.time_zone_value === "")) {
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please Enter Time Zone Value",
      });

      return;
    }

    var bodyObject = {
      user_id: this.state.user_id,
      token: this.state.token,
      city: this.state.city,
      email: this.state.email,
      user_type: this.state.userType,
      password: this.state.password,
      mobile: this.state.mobile,
      ret_user_id: this.props.match.params.id,
      fullname: this.state.fullname,
      email_cost: this.state.email_cost,
      country: this.state.country,
      spam_bypass: this.state.spam_bypass,
      address_line_1: this.state.address_line_1,
      template_editable: this.state.template_editable,
      expiry: this.state.updateExpirydate,
      parent: this.state.parent.value,
      whitelist_ip: this.state.whiteLableIP,
      enable_ip_whitelist: this.state.enable_ip_whitelist,
      aws_setting: this.state.awsSetting,
      embsignup_routeid: this.state.embededSignup,

      sms_menu: this.state.checkBox.sms,
      voice_menu: this.state.checkBox.voice,
      email_menu: this.state.checkBox.email,
      whatsapp_menu: this.state.checkBox.whatsapp,
      rechrg_menu: this.state.checkBox.recharge,
      notify_menu: this.state.checkBox.notification,
      rich_menu: this.state.checkBox.rich_media,
      fb_menu: this.state.checkBox.fallback,
      rcs_menu: this.state.checkBox.rcs,
      chat_menu: this.state.checkBox.chat,
      flow_menu: this.state.checkBox.flow,
      time_zone: this.state.time_zone,
      time_zone_value: this.state.time_zone_value,

      method: "update",
    };
    //console.log(bodyObject);
    fetch(`${server}/api/admin_user_list.php`, {
      method: "post",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(bodyObject),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp.success === true) {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-success alert-dismissible",
            errorMessage: resp.message,
          });
        } else {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: resp.message,
          });
        }
      });
    });
  }

  handleEmbededSignupChange = (event) => {
    const selectedRoute = event.target.value;

    this.setState({ embededSignup: selectedRoute });
    localStorage.setItem("embededSignup", selectedRoute);
  };

  dateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    if (this.state.user_id == 4784 || this.state.userType === "reseller" || "admin") {
      this.setState({
        expiryDate: dated,
        updateExpirydate: dated,
        SelecteddateFrom: date,
      });
    }
  };

  spamHandlar = (e) => {
    if (e.target.checked === true) {
      this.setState({ spam_bypass: 1 });
    } else {
      this.setState({ spam_bypass: 0 });
    }
  };

  awsHandler = (e) => {
    if (e.target.checked === true) {
      this.setState({ awsSetting: 1 });
    } else {
      this.setState({ awsSetting: 0 });
    }
  };

  whiteLabelHandlar(e) {
    const { checked } = e.target;
    if (checked === true) {
      this.setState({ enable_ip_whitelist: 1 });
    } else {
      this.setState({ enable_ip_whitelist: 0, whiteLableIP: "" });
    }
  }

  eyeToggle(e) {
    e.preventDefault();
    this.setState((prevState) => ({
      eyeIconToggle: !prevState.eyeIconToggle,
    }));
  }

  handlePass(e) {
    this.setState({
      password: e.target.value,
    });
    if (e.target.value === "" && this.state.cnfmPassword === "")
      this.setState({
        passError: 0,
      });
  }

  handleCnfmPass(e) {
    if (e.target.value === "" && this.state.password === "")
      this.setState({
        passError: 0,
      });

    if (this.state.password === "") {
      return;
    } else {
      this.setState({
        passError: 1,
      });
    }
    const pass = this.state.password;
    const cnfmPass = e.target.value;
    this.setState({
      cnfmPassword: e.target.value,
    });
    if (pass === cnfmPass) {
      this.setState({
        passError: 0,
      });
    } else {
      this.setState({
        passError: 1,
      });
    }
  }

  handleCheckboxAll(e) {
    const { checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        all: value,
        sms: value,
        voice: value,
        email: value,
        whatsapp: value,
        recharge: value,
        notification: value,
        rich_media: value,
        fallback: value,
        rcs: value,
        chat: value,
        flow: value,
      },
    }));
  }

  handleCheckbox = (e) => {
    const { name, checked } = e.target;
    let value;
    if (checked === true) {
      value = 1;
    } else {
      value = 0;
    }
    this.setState((prevState) => ({
      checkBox: {
        ...prevState.checkBox,
        [name]: value,
      },
    }));
  };


  customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "pointer",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (style) => ({
      ...style,
      fontSize: "12px",
    }),
  };

  render() {


    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    User Details{" "}
                    <strong className="text-info">
                      {" "}
                      {this.state.selectUserDetails.email}{" "}
                    </strong>{" "}
                  </h3>
                </div>

                {this.state.successMessage ? (
                  <div className={this.state.bgColor} role="alert">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                    <div className="">{this.state.errorMessage}</div>
                  </div>
                ) : null}
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <div >
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link
                              to={
                                "/admin/user-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              <li className="breadcrumb-item active">
                                User Details{" "}
                              </li>{" "}
                            </Link>

                            {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.subAdminPermission.transactiondetails)) && 
                            <Link
                              to={
                                "/admin/user-transaction-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              <li className="breadcrumb-item">
                                {" "}
                                Transaction Details{" "}
                              </li>
                            </Link>}

                            {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.subAdminPermission.addeditprice)) && 
                            <Link
                              to={
                                "/admin/user-price-details/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType + `?` + "channel=whatsapp"
                              }
                            >
                              <li className="breadcrumb-item"> Add Price </li>
                            </Link>}
                            
                               {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.awssettings)) &&(
                              <Link
                                to={
                                  "/admin/aws-settings/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType
                                }
                              >
                                {" "}
                                <li className="breadcrumb-item">
                                  {" "}
                                  AWS Settings{" "}
                                </li>
                              </Link>
                              )}

                            {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.billingmode)) && (
                              <Link
                                to={
                                  "/admin/user-billing-mode/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType
                                }
                              >
                                {" "}
                                <li className="breadcrumb-item">
                                  {" "}
                                  Billing Mode{" "}
                                </li>
                              </Link>
                            )}

                            {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.subAdminPermission.addeditcredit)) && 
                            <Link
                              to={
                                "/admin/user-add-price/" +
                                this.state.seletedUserId +
                                `/` +
                                this.state.selectedUserType
                              }
                            >
                              {" "}
                              <li className="breadcrumb-item">
                                {" "}
                                Add Credit{" "}
                              </li>
                            </Link>}

                            {this.state.userType === "reseller" ? null : (
                              <>
                                    {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.entitybypass)) && 
                                    <Link
                                      to={
                                        "/admin/user-entity-pass/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item">
                                        {" "}
                                        Entity By Pass{" "}
                                      </li>
                                    </Link>}

                                   {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.changecurrency)) &&  
                                   <Link
                                      to={
                                        "/admin/change-currency/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item ">
                                        {" "}
                                        Change Currency{" "}
                                      </li>
                                    </Link>}

                                    {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.bulksmsroutesetting)) && 
                                    <Link
                                      to={
                                        "/admin/bulk-sms-route/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item ">
                                        {" "}
                                        Bulk Sms Route Setting{" "}
                                      </li>
                                    </Link>}
                               
                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.autoshorturl)) && 
                                 <Link
                                  to={`/admin/api-auto-short-url/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Auto Short URL
                                  </li>
                                </Link>}
                                  {/* {this.state.userType === "admin" && 
                                 <Link
                                  to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Extra Settings
                                  </li>
                                </Link>} */}
                                 {((this.state.userType === "admin" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.subAdminPermission.extrasettings))) && 
                                 <Link
                                  to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li 
                                  className="breadcrumb-item"
                                  >
                                    Extra Settings
                                  </li>
                                </Link>
                                }

                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.extrasettings)) &&
                                  <Link
                                    to={`/admin/mmlite/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      MMLite
                                    </li>
                                  </Link>}
                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.ai_bot)) &&
                                  <Link
                                    to={`/admin/ai-bot/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      AI Bot
                                    </li>
                                  </Link>}

                                  {/* adding similar button to edit the user plan and linking its route to EditUSerPLan.js inside UserPLan folder */}
                                  {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.subAdminPermission.edituserplan)) &&
                                  <Link
                                    to={`/admin/edit-user-plan/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Edit User Plan
                                    </li>
                                  </Link>}

                                   {/* {this.state.userType === "admin" &&
                                  <Link
                                    to={`/admin/ivr-setting/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      IVR Setting
                                    </li>
                                  </Link>} */}
                              </>
                            )}
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div className=" flex-fill">
                          <form>
                            <div className="row">
                              <div className="mb-3 col-md-4">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Full Name
                                </label>
                                <input
                                  type="text"
                                  readOnly={
                                    this.state.userType === "reseller"
                                      ? true
                                      : false
                                  }
                                  defaultValue={
                                    this.state.selectUserDetails.fullname
                                  }
                                  onChange={(event) =>
                                    this.setState({
                                      fullname: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Enter Full Name"
                                />
                              </div>
                              <div className="mb-3 col-md-4">
                                <label
                                  className="form-label"
                                  htmlFor="inputEmail4"
                                >
                                  Email
                                </label>
                                <input
                                  defaultValue={
                                    this.state.selectUserDetails.email
                                  }
                                  type="email"
                                  readOnly
                                  className="form-control"
                                  placeholder="Email"
                                />
                              </div>
                              <div className="mb-3 col-md-4">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Enter Mobile Number
                                </label>
                                <input
                                  type="text"
                                  readOnly={
                                    this.state.userType === "reseller"
                                      ? true
                                      : false
                                  }
                                  defaultValue={
                                    this.state.selectUserDetails.mobile
                                  }
                                  onChange={(event) =>
                                    this.setState({
                                      mobile: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                  placeholder="Enter 10 Digit Mobile Number"
                                />
                              </div>
                            </div>

                            {/* <div className="row">
                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Password
                                </label>
                                <div className="d-flex flex-row">
                                  <input
                                    type={
                                      this.state.eyeIconToggle === true
                                        ? "text"
                                        : "password"
                                    }
                                    defaultValue={this.state.password}
                                    onChange={this.handlePass}
                                    className="form-control"
                                    placeholder="Enter new password"
                                    required
                                  />

                                  <button
                                    className="border-0 "
                                    onClick={this.eyeToggle}
                                  >
                                    {this.state.eyeIconToggle === true ? (
                                      <FontAwesomeIcon icon={faEyeSlash} />
                                    ) : (
                                      <FontAwesomeIcon icon={faEye} />
                                    )}
                                  </button>
                                </div>
                              </div>

                              <div className="mb-3 col-md-6">
                                <label
                                  className="form-label"
                                  htmlFor="inputFirstName"
                                >
                                  Confrim Password
                                </label>
                                <div className="d-flex flex-row">
                                  <input
                                    type={
                                      this.state.eyeIconToggle === true
                                        ? "text"
                                        : "password"
                                    }
                                    defaultValue={this.state.cnfmPassword}
                                    onChange={this.handleCnfmPass}
                                    className="form-control"
                                    placeholder="Enter new password"
                                    required
                                  />
                                  <button
                                    className="border-0 "
                                    onClick={this.eyeToggle}
                                  >
                                    {this.state.eyeIconToggle === true ? (
                                      <FontAwesomeIcon icon={faEyeSlash} />
                                    ) : (
                                      <FontAwesomeIcon icon={faEye} />
                                    )}
                                  </button>
                                </div>

                                {this.state.passError === 1 && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "10px" }}
                                  >
                                    *The passwords you entered don't match
                                  </p>
                                )}
                              </div>
                            </div> */}

                            {this.state.userType === "reseller" ? null : (
                              <>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="inputAddress"
                                  >
                                    Address
                                  </label>
                                  <textarea
                                    defaultValue={
                                      this.state.selectUserDetails
                                        .address_line_1
                                    }
                                    className="form-control"
                                    onChange={(event) =>
                                      this.setState({
                                        address_line_1: event.target.value,
                                      })
                                    }
                                    placeholder="1234 Main St"
                                  ></textarea>
                                </div>
                              </>
                            )}
                            <div className="row">
                              {this.state.userType === "reseller" ? null : (
                                <>
                                  <div className="mb-3 col-md-4">
                                    <label
                                      className="form-label"
                                      htmlFor="inputCity"
                                    >
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        this.state.selectUserDetails.country
                                      }
                                      onChange={(event) =>
                                        this.setState({
                                          country: event.target.value,
                                        })
                                      }
                                      placeholder="Country"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="mb-3 col-md-4">
                                    <label
                                      className="form-label"
                                      htmlFor="inputCity"
                                    >
                                      City
                                    </label>
                                    <input
                                      defaultValue={
                                        this.state.selectUserDetails.city
                                      }
                                      onChange={(event) =>
                                        this.setState({
                                          city: event.target.value,
                                        })
                                      }
                                      type="text"
                                      placeholder="City"
                                      className="form-control"
                                    />
                                  </div>
                                </>
                              )}

                              {this.state.userType === "admin" ? (
                                <div className="mb-3 col-md-4">
                                  <label
                                    className="form-label"
                                    htmlFor="inputCity"
                                  >
                                    Select Parent
                                  </label>



                                  <Select
                                    onChange={(selectedOption) =>
                                      this.setState({
                                        parent: selectedOption,
                                      })

                                    }
                                    options={this.state.employeeList}
                                    value={this.state.parent}
                                    isSearchable={true}
                                    placeholder="Select Parent"
                                    isClearable={true}
                                    styles={this.customStyles}
                                  // isLoading={loading}
                                  />
                                </div>
                              ) : null}
                            </div>
                            <div className="row">
                              {this.state.userType === "admin" && (
                                <>
                                  <div className="mb-3 col-md-4">
                                    <label className="form-label" htmlFor="embededSignup">
                                      Embeded Signup
                                    </label>
                                    <select
                                      onChange={this.handleEmbededSignupChange}
                                      value={this.state.embededSignup}
                                      className="form-control"
                                    >

                                      <option value="0"> Select Route</option>
                                      <option value="41">Karix</option>
                                      <option value="36">Pinnacle</option>
                                      <option value="1001">Karix Coex</option>
                                    </select>
                                  </div>

                                  <div className="mb-3 col-md-4">
                                    <label className="form-label" htmlFor="embededSignup">
                                      Time Zone
                                    </label>
                                    <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                      <div className="input-group mb-2 mr-sm-2 ">
                                        {/* <div className="input-group-text">User </div> */}
                                        <select
                                          onChange={(e) => this.setState({ time_zone: e.target.value })}
                                          value={this.state.time_zone}
                                          className="form-control"
                                        >

                                          <option value="0"> Select Time Zone</option>
                                          <option value="IST">IST</option>
                                          <option value="UTC">UTC</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-3 col-md-4">
                                    <label className="form-label" htmlFor="embededSignup">
                                      Time Zone Value
                                    </label>{this.state.time_zone === "UTC" && <span style={{ color: "red" }}>*</span>}
                                    <input type="text" value={this.state.time_zone_value} className="form-control" onChange={(e) => this.setState({ time_zone_value: e.target.value })} placeholder="Enter Time Zone" />
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="row">
                              {this.state.userType === "reseller" ? null : (
                                <>
                                  <div className="col-md-3">
                                    <label
                                      className="form-label"
                                      htmlFor="inputCity"
                                    >
                                      Email Cost
                                    </label>
                                    <input
                                      defaultValue={
                                        this.state.selectUserDetails.email_cost
                                      }
                                      onChange={(event) =>
                                        this.setState({
                                          email_cost: event.target.value,
                                        })
                                      }
                                      type="text"
                                      placeholder="City"
                                      className="form-control"
                                    />
                                  </div>

                                  <div className="col-md-4">
                                    <label
                                      className="form-label"
                                      htmlFor="inputCity"
                                    >
                                      Template Editable{" "}
                                    </label>

                                    <select
                                      className="form-control"
                                      value={this.state.template_editable}
                                      onChange={(event) =>
                                        this.setState({
                                          template_editable: event.target.value,
                                        })
                                      }
                                    >
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </select>
                                  </div>
                                </>
                              )}

                              <div className="col-md-5">
                                <label
                                  className="form-label "
                                  htmlFor="inputCity"
                                >
                                  Extend user validity{" "}
                                </label>
                                <div className="input-group mb-2 mr-sm-2">
                                  <div className="input-group-text">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                  </div>
                                  <DatePicker
                                    className={`form-control btn-block `}
                                    dateFormat="yyyy-MM-dd"
                                    renderCustomHeader={this.renderCustomHeader}
                                    // value={this.state.expiryDate}
                                    onChange={this.dateFrom}
                                    selected={this.state.SelecteddateFrom}
                                    placeholderText="From Date"

                                    disabled={this.state.userType === "reseller" || "admin" ? false : true}
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-4">
                                  <h6>Channels</h6>
                                </div>
                              </div>



                              <div className="row ml-2">
                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.sms_menu === 1 && this.state.userDtl.user.voice_menu === 1 && this.state.userDtl.user.email_menu === 1 && this.state.userDtl.user.whatsapp_menu === 1 && this.state.userDtl.user.rechrg_menu === 1 && this.state.userDtl.user.notify_menu === 1 && this.state.userDtl.user.rich_menu === 1 && this.state.userDtl.user.fb_menu === 1 && this.state.userDtl.user.rcs_menu === 1 && this.state.userDtl.user.chat_menu === 1 && this.state.userDtl.user.flow === 1)) ?
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      checked={
                                        this.state.checkBox.all === 1
                                          ? true
                                          : false
                                      }
                                      name="all"
                                      value={this.state.checkBox.all}
                                      onChange={this.handleCheckboxAll}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      All
                                    </label>
                                  </div> : null}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.sms_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      checked={
                                        this.state.checkBox.sms === 1
                                          ? true
                                          : false
                                      }
                                      name="sms"
                                      value={this.state.checkBox.sms}
                                      onChange={this.handleCheckbox}
                                      id="flexCheckDefault"
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      SMS
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.voice_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="voice"
                                      checked={
                                        this.state.checkBox.voice === 1
                                          ? true
                                          : false
                                      }
                                      value={this.state.checkBox.voice}
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Voice
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.email_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      value={this.state.checkBox.email}
                                      checked={
                                        this.state.checkBox.email === 1
                                          ? true
                                          : false
                                      }
                                      name="email"
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Email
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.whatsapp_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="whatsapp"
                                      value={this.state.checkBox.whatsapp}
                                      checked={
                                        this.state.checkBox.whatsapp === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Whatsapp
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rechrg_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="recharge"
                                      value={this.state.checkBox.recharge}
                                      checked={
                                        this.state.checkBox.recharge === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Recharge
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.notify_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="notification"
                                      value={this.state.checkBox.notification}
                                      checked={
                                        this.state.checkBox.notification === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Notification
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rich_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="rich_media"
                                      value={this.state.checkBox.rich_media}
                                      checked={
                                        this.state.checkBox.rich_media === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Rich Media
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.fb_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="fallback"
                                      value={this.state.checkBox.fallback}
                                      checked={
                                        this.state.checkBox.fallback === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Fallback
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.rcs_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="rcs"
                                      value={this.state.checkBox.rcs}
                                      checked={
                                        this.state.checkBox.rcs === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      RCS
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.chat_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="chat"
                                      value={this.state.checkBox.chat}
                                      checked={
                                        this.state.checkBox.chat === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Chat
                                    </label>
                                  </div>}

                                {((this.state.userDtl.user.isAdmin === "admin") || (this.state.userDtl.user.isAdmin !== "admin" && this.state.userDtl.user.flow === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="flow"
                                      value={this.state.checkBox.flow}
                                      checked={
                                        this.state.checkBox.flow === 1
                                          ? true
                                          : false
                                      }
                                      onChange={this.handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      Flow
                                    </label>
                                  </div>}
                              </div>

                              {this.state.userType === "reseller" || this.state.userType === "emp" ? null : (
                                <>
                                  <div className="col-md-4 mt-5">
                                    <div className="ml-4">
                                      <input
                                        onChange={this.spamHandlar}
                                        type="checkbox"
                                        checked={this.state.spam_bypass}
                                        className="form-check-input mr-2"
                                        id="fallback"
                                      />{" "}
                                      <span className="p-2">Spam By Pass </span>
                                    </div>
                                  </div>

                                  <div className="col-md-4 mt-5">
                                    <div className="ml-4">
                                      <input
                                        defaultChecked={
                                          this.state.enable_ip_whitelist
                                            ? "checked"
                                            : null
                                        }
                                        onClick={(e) =>
                                          this.whiteLabelHandlar(e)
                                        }
                                        type="checkbox"
                                        className="form-check-input mr-2"
                                        id="fallback"
                                      />{" "}
                                      <span className="p-2">
                                        Add White Label IP Address{" "}
                                      </span>
                                    </div>

                                    {this.state.enable_ip_whitelist ===
                                      0 ? null : (
                                      <div className="mt-2">
                                        <input
                                          onChange={(event) =>
                                            this.setState({
                                              whiteLableIP: event.target.value,
                                            })
                                          }
                                          type="text"
                                          defaultValue={this.state.whiteLableIP}
                                          placeholder="Example : 192.168.4.2, 193.168.4.2, 196.128.4.2"
                                          className="form-control"
                                        />
                                        <small className="form-text text-info text-muted">
                                          Add comma(,) if you have multiple IP
                                          address
                                        </small>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-md-4 mt-5">
                                    <div className="ml-4">
                                      <input
                                        onChange={this.awsHandler}
                                        type="checkbox"
                                        checked={this.state.awsSetting}
                                        className="form-check-input mr-2"
                                        id="fallback"
                                      />{" "}
                                      <span className="p-2"> AWS Setting </span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>


                            <hr />

                            <div className="float-right">
                              <input
                                onClick={() => this.UpdateUserDetails()}
                                type="button"
                                value="Update User Details"
                                className="btn btn-sm  btn-primary"
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <div></div>
            </div>
          </main>
          <AdminFooter />
        </div>
        
      </div>
    );
  }
}

export default UserDetails;
